/* eslint-disable no-unused-vars */
import usePageMeta from "utils/usePageMeta";
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

// Layout
import SubPageLayout from "reusables/layouts/SubPageLayout";

// Sections
import FAQ_Section1 from "./sections/FAQ_Section1";
import FAQ_Section2 from "./sections/FAQ_Section2";

function FAQ() {
  usePageMeta({
    title: "FAQ | Spechs Ireland",
    description:
      "Frequently asked questions about Spechs cleaning, property management, and workforce services.",
    canonical: "https://www.spechs.ie/faq/",
  });
  return (
    <SubPageLayout title="Frequently Asked Questions">
      <MKBox component="section" py={{ xs: 3, md: 12 }}>
        <FAQ_Section1 />
      </MKBox>
      <MKBox component="section" py={{ xs: 3, md: 12 }}>
        <FAQ_Section2 />
      </MKBox>
    </SubPageLayout>
  );
}

export default FAQ;
